function gettersConstructor(dependencyHash) {
  const getters = {};

  return getters;
}

export default gettersConstructor;
